// Imports
import axios from 'axios';

// Asset export actions
/**
 * Get all Assets.
 * @param {Object} { token: string, query: string, direction: string, order: string, limit: number, page: number}
 * @return {AxiosPromise} Http request
 */
export const getAssets = ({ token, query, direction, order, limit, page }) => {
  const params = {
    q: query || null,
    direction,
    order,
    limit,
    page,
  };

  let urlString = '';

  Object.keys(params).map(i => {
    urlString += params[i] ? `&${i}=${params[i]}` : '';
    return i;
  });

  urlString = urlString.length > 0 ? `?${urlString.slice(1)}` : '';

  return axios({
    method: 'get',
    url: `${window.API_URL}/assets${urlString}`,
    headers: { Authorization: `Bearer ${token}` },
  });
};

/**
 * Get an Asset
 * @param {Object} { token: string, id: number}
 * @return {AxiosPromise} Http request
 */
export const getAsset = ({ token, id }) => {
  const params = {
    id,
  };

  let urlString = '';

  Object.keys(params).map(i => {
    urlString += params[i] ? `&${i}=${params[i]}` : '';
    return i;
  });

  urlString = urlString.length > 0 ? `?${urlString.slice(1)}` : '';

  return axios({
    method: 'get',
    url: `${window.API_URL}/assets${urlString}`,
    headers: { Authorization: `Bearer ${token}` },
  });
};

/**
 * Create an Asset
 * @param {Object} { token: string, payload: {File Data Object} }
 * @return {AxiosPromise} Http request
 */
export const createAsset = ({ token, payload, onProgress }) =>
  axios({
    method: 'post',
    url: `${window.API_URL}/assets`,
    data: payload,
    onProgress: onProgress,
    headers: { Authorization: `Bearer ${token}` },
  });

/**
 * Delete an Asset
 * @param {Object} { token: string, id: integer }
 * @return {Promise} axios promise
 */
export const deleteAsset = ({ token, id }) => {
  return axios({
    method: 'delete',
    url: `${window.API_URL}/assets/${id}`,
    headers: { Authorization: `Bearer ${token}` },
  });
};
